import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)`
  max-width: 600px;
  margin-top: 150px;
`;

const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-weight: bold;
`;
const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const NotFound = () => (
  <React.StrictMode>
    <Helmet>
      <title>404 | Material Kit</title>
    </Helmet>
    <StyledBox>
      <StyledContainer maxWidth='md'>
        <StyledTypography align='center' color='textPrimary' variant='h1'>
          404: The page you are looking for isn’t here
        </StyledTypography>
        <StyledTypography
          align='center'
          color='textPrimary'
          variant='subtitle2'
        >
          You either tried some shady route or you came here by mistake.
          Whichever it is, try using the navigation
        </StyledTypography>
        <Box sx={{ textAlign: 'center' }}>
          <img
            alt='Under development'
            src='/static/images/undraw_page_not_found_su7k.svg'
            style={{
              marginTop: 50,
              display: 'inline-block',
              maxWidth: '100%',
              width: 560
            }}
          />
        </Box>
      </StyledContainer>
    </StyledBox>
  </React.StrictMode>
);

export default NotFound;
